<script>
import ModalCoursePromotionalVideoComponent from '../../features/modals/ModalCoursePromotionalVideoComponent';
export default {
  name: 'ModalCoursePromotionalVideoView',
  extends: ModalCoursePromotionalVideoComponent,
};
</script>

<template>
  <el-dialog
    v-model="conf.isVisible"
    title="Video Promocional"
    width="42%"
    class="course-promotional-video-modal"
    append-to-body
    :before-close="onCancel"
    :close-on-click-modal="false"
  >
    <el-row v-if="formData">
      <el-col
        :span="24"
        align="center"
      >
        <iframe
          v-if="formData.promotionalVideoUrl"
          :src="formData.promotionalVideoUrl"
          width="750"
          height="450"
          frameborder="0"
          allow="autoplay; fullscreen; unload"
          allowfullscreen
        />
      </el-col>
    </el-row>
  </el-dialog>
</template>
